/* 
  MF Simulator: Youtube Player
*/

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Youtube = ({ video, onClose }) => {
  return (
    <div className="youtube-overlay">
      <button className="btn-close-youtube" onClick={onClose} aria-label="Close">
        <FontAwesomeIcon icon={['fas', 'xmark']} />
      </button>
      <iframe
        src={video} // Use the video prop for the YouTube URL
        title="YouTube video"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        className="youtube-frame"
      ></iframe>
    </div>
  );
};

export default Youtube;